module.exports = __webpack_public_path__ + "img/header_bg.890c7d7.png";